import { Component, input } from '@angular/core';
import { QRCodeComponent } from 'angularx-qrcode';

@Component({
   selector: 'app-qr-code',
   standalone: true,
   imports: [QRCodeComponent],
   templateUrl: './qr-code.component.html',
})
export class QrCodeComponent {
   readonly data = input<string>('');
   readonly width = input<number>(150);
}
